import '../App.css'
import Header from './Header';
import Menu from './Menu';

function Home (){
    return(
        <div className='Home'>
        <Header/>
        <Menu/>
        </div>
    )
}

export default Home;